module.exports = __webpack_public_path__ + "static/media/profile.8a5f0958.svg";